// @Version: 1.0.3
import { Injectable } from "@angular/core";
import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { FC_NUMBER } from "./number.model";
import { VALIDATORS } from "../field-item.model";

@Injectable({
   providedIn: 'root'
})

export class CustomValidators {

   constructor () { }

   public isPosValid (fg: FormGroup): ValidatorFn {
      return (): ValidationErrors | null => {
 
         if (!fg.dirty) return null;
         if (fg.get(FC_NUMBER.NUMBER)?.value.length == 0) return null;
         const numberValue = !+fg.get(FC_NUMBER.NUMBER)?.value ? +(fg.get(FC_NUMBER.NUMBER)?.value.replaceAll('.','').replaceAll(',','.')): +fg.get(FC_NUMBER.NUMBER)?.value; 
         return numberValue >= 0 ?  null : { [VALIDATORS.positiv]: true };
      }
   }

   public isMaxValid (fg: FormGroup, max: number): ValidatorFn {
      return (): ValidationErrors | null => {
 
         if (!fg.dirty) return null;
         if (fg.get(FC_NUMBER.NUMBER)?.value.length == 0) return null;
         const numberValue = !+fg.get(FC_NUMBER.NUMBER)?.value ? +(fg.get(FC_NUMBER.NUMBER)?.value.replaceAll('.','').replaceAll(',','.')): +fg.get(FC_NUMBER.NUMBER)?.value; 
         return numberValue <= max ?  null : { [VALIDATORS.maxnumber]: true };
      }
   }

   public isMinValid (fg: FormGroup, min: number): ValidatorFn {
      return (): ValidationErrors | null => {
         if (!fg.dirty) return null;
         if (fg.get(FC_NUMBER.NUMBER)?.value.length == 0) return null;
         const numberValue = !+fg.get(FC_NUMBER.NUMBER)?.value ? +(fg.get(FC_NUMBER.NUMBER)?.value.replaceAll('.','').replaceAll(',','.')): +fg.get(FC_NUMBER.NUMBER)?.value; 
         return numberValue >= min ?  null : { [VALIDATORS.minnumber]: true };
      }
   }

   public isNegValid (fg: FormGroup): ValidatorFn {
      return (): ValidationErrors | null => {
         if (!fg.dirty) return null;
         if (fg.get(FC_NUMBER.NUMBER)?.value.length == 0) return null;
         const numberValue = !+fg.get(FC_NUMBER.NUMBER)?.value ? +(fg.get(FC_NUMBER.NUMBER)?.value.replaceAll('.','').replaceAll(',','.')): +fg.get(FC_NUMBER.NUMBER)?.value; 
         return numberValue < 0 ? null : {  [VALIDATORS.negativ]: true };
      }
   }

   public isRangeValid (fg: FormGroup, min: number, max: number): ValidatorFn {
      return (): ValidationErrors | null => {
         if (!fg.dirty) return null;
         if (fg.get(FC_NUMBER.NUMBER)?.value.length == 0) return null;
         const numberValue = !+fg.get(FC_NUMBER.NUMBER)?.value ? +(fg.get(FC_NUMBER.NUMBER)?.value.replaceAll('.','').replaceAll(',','.')): +fg.get(FC_NUMBER.NUMBER)?.value; 
         return (numberValue >= min && numberValue <= max) ? null : { [VALIDATORS.range]: true };
      }
   }
}